import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AdminLayout from '../../components/AdminLayout/AdminLayout';
import './Message2Page.css';

// Icons as SVG components
const ThreeDotsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5 4.5C10.5 3.90326 10.7371 3.33097 11.159 2.90901C11.581 2.48705 12.1533 2.25 12.75 2.25C13.3467 2.25 13.919 2.48705 14.341 2.90901C14.7629 3.33097 15 3.90326 15 4.5C15 5.09674 14.7629 5.66903 14.341 6.09099C13.919 6.51295 13.3467 6.75 12.75 6.75C12.1533 6.75 11.581 6.51295 11.159 6.09099C10.7371 5.66903 10.5 5.09674 10.5 4.5ZM10.5 12C10.5 11.4033 10.7371 10.831 11.159 10.409C11.581 9.98705 12.1533 9.75 12.75 9.75C13.3467 9.75 13.919 9.98705 14.341 10.409C14.7629 10.831 15 11.4033 15 12C15 12.5967 14.7629 13.169 14.341 13.591C13.919 14.0129 13.3467 14.25 12.75 14.25C12.1533 14.25 11.581 14.0129 11.159 13.591C10.7371 13.169 10.5 12.5967 10.5 12ZM10.5 19.5C10.5 18.9033 10.7371 18.331 11.159 17.909C11.581 17.4871 12.1533 17.25 12.75 17.25C13.3467 17.25 13.919 17.4871 14.341 17.909C14.7629 18.331 15 18.9033 15 19.5C15 20.0967 14.7629 20.669 14.341 21.091C13.919 21.5129 13.3467 21.75 12.75 21.75C12.1533 21.75 11.581 21.5129 11.159 21.091C10.7371 20.669 10.5 20.0967 10.5 19.5Z" fill="#6D6D6D"/>
  </svg>
);

const AttachIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z" fill="#1F396C"/>
  </svg>
);

const SendIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" fill="#1F396C"/>
    <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z" fill="white"/>
  </svg>
);

// Sample data for inbox messages
const inboxMessages = [
  { id: 1, name: 'Ms. Lomen Fan', role: 'Sales Manager', time: '3 days ago', message: 'Fully furnished, with a turnkey setup, trained staff, and high online ratings. Great opportunity for a hands-on operator or investor.', active: true },
  { id: 2, name: 'Ms. Lomen Fan', role: 'Sales Manager', time: '3 days ago', message: 'Fully furnished, with a turnkey setup, trained staff, and high online ratings. Great opportunity for a hands-on operator or investor.', active: false },
  { id: 3, name: 'Ms. Lomen Fan', role: 'Sales Manager', time: '3 days ago', message: 'Fully furnished, with a turnkey setup, trained staff, and high online ratings. Great opportunity for a hands-on operator or investor.', active: false },
  { id: 4, name: 'Ms. Lomen Fan', role: 'Sales Manager', time: '3 days ago', message: 'Fully furnished, with a turnkey setup, trained staff, and high online ratings. Great opportunity for a hands-on operator or investor.', active: false },
  { id: 5, name: 'Ms. Lomen Fan', role: 'Sales Manager', time: '3 days ago', message: 'Fully furnished, with a turnkey setup, trained staff, and high online ratings. Great opportunity for a hands-on operator or investor.', active: false },
  { id: 6, name: 'Ms. Lomen Fan', role: 'Sales Manager', time: '3 days ago', message: 'Fully furnished, with a turnkey setup, trained staff, and high online ratings. Great opportunity for a hands-on operator or investor.', active: false },
  { id: 7, name: 'Ms. Lomen Fan', role: 'Sales Manager', time: '3 days ago', message: 'Fully furnished, with a turnkey setup, trained staff, and high online ratings. Great opportunity for a hands-on operator or investor.', active: false },
  { id: 8, name: 'Ms. Lomen Fan', role: 'Sales Manager', time: '3 days ago', message: 'Fully furnished, with a turnkey setup, trained staff, and high online ratings. Great opportunity for a hands-on operator or investor.', active: false },
];

// Sample chat messages
const chatMessages = [
  { id: 1, text: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,", time: '8:00 PM', isUser: true },
  { id: 2, text: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,", time: '8:00 PM', isUser: true },
  { id: 3, text: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,", time: '8:00 PM', isUser: false },
  { id: 4, text: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,", time: '8:00 PM', isUser: true },
  { id: 5, text: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,", time: '8:00 PM', isUser: true },
  { id: 6, text: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,", time: '8:00 PM', isUser: false },
  { id: 7, text: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,", time: '8:00 PM', isUser: false },
];

const Message2Page = () => {
  const [searchParams] = useSearchParams();
  const sellerId = searchParams.get('seller');
  const { user } = useAuth();
  const [messageText, setMessageText] = useState('');
  const [selectedMessage, setSelectedMessage] = useState(inboxMessages[0]);

  useEffect(() => {
    // If a seller ID is provided, we could fetch seller-specific messages here
    if (sellerId) {
      console.log('Loading messages for seller:', sellerId);
    }
  }, [sellerId]);

  return (
    <AdminLayout>
      <div className="message2-content">
        {/* Inbox Panel */}
        <div className="inbox-panel">
          <div className="inbox-header">
            <h2>Inbox</h2>
          </div>
          <div className="inbox-list">
            {inboxMessages.map((msg) => (
              <div 
                key={msg.id} 
                className={`inbox-item ${msg.active || selectedMessage?.id === msg.id ? 'active' : ''}`}
                onClick={() => setSelectedMessage(msg)}
              >
                <img 
                  src="https://api.builder.io/api/v1/image/assets/TEMP/561da124ca9a57c1461a9da91c830f61842922c8?width=104" 
                  alt={msg.name}
                  className="inbox-avatar"
                />
                <div className="inbox-item-content">
                  <div className="inbox-item-header">
                    <div className="inbox-item-name">
                      <span className="name">{msg.name}</span>
                      <span className="role">{msg.role}</span>
                    </div>
                    <div className="inbox-item-meta">
                      <span className="time">{msg.time}</span>
                      <ThreeDotsIcon />
                    </div>
                  </div>
                  <p className="inbox-item-preview">{msg.message}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Chat Panel */}
        <div className="chat-panel">
          <div className="chat-header">
            <img 
              src="https://api.builder.io/api/v1/image/assets/TEMP/561da124ca9a57c1461a9da91c830f61842922c8?width=104" 
              alt={selectedMessage?.name}
              className="chat-avatar"
            />
            <div className="chat-user-info">
              <span className="name">{selectedMessage?.name}</span>
              <span className="role">{selectedMessage?.role}</span>
            </div>
          </div>
          <div className="chat-messages">
            {chatMessages.map((msg) => (
              <div key={msg.id} className={`chat-message ${msg.isUser ? 'user' : 'other'}`}>
                <div className="message-content">
                  <div className="message-bubble">
                    <p>{msg.text}</p>
                  </div>
                  <span className="message-time">{msg.time}</span>
                </div>
                <div className="message-avatar">
                  <img 
                    src={msg.isUser 
                      ? "https://api.builder.io/api/v1/image/assets/TEMP/f818f7858deb5c33fb024ebcc971e46301760100?width=138"
                      : "https://api.builder.io/api/v1/image/assets/TEMP/04c07c179b532a2bad5f44a8cbded1711abbd870?width=138"
                    } 
                    alt="User"
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="chat-input">
            <input 
              type="text" 
              placeholder="Type message" 
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
            />
            <div className="chat-actions">
              <button className="attach-btn">
                <AttachIcon />
              </button>
              <button className="send-btn">
                <SendIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Message2Page;
